module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/transaction-refund-box/transaction-refund-box.component.scss
// module id = ./src/app/modules/boxoffice-module/common/transaction-refund-box/transaction-refund-box.component.scss
// module chunks = 9